export const DEFAULT_DASHBOARD_TABS = [
  { id: 'add', label: 'Add Transaction', visible: true, mode: 'builtin', fields: [] },
  { id: 'transactions', label: 'Inventory Ledger', visible: true, mode: 'builtin', fields: [] },
  { id: 'stock', label: 'Stock Overview', visible: true, mode: 'builtin', fields: [] },
  { id: 'insights', label: 'Insights', visible: true, mode: 'builtin', fields: [] },
  { id: 'pipeline_board', label: 'Order Workflow', visible: true, mode: 'builtin', fields: [] },
  { id: 'product_add', label: 'Add Product', visible: true, mode: 'builtin', fields: [] },
  { id: 'products', label: 'View Products', visible: true, mode: 'builtin', fields: [] },
  { id: 'order', label: 'Create Order', visible: true, mode: 'builtin', fields: [] },
  { id: 'orders', label: 'View Orders', visible: true, mode: 'builtin', fields: [] },
  { id: 'staff', label: 'Staff', visible: true, mode: 'builtin', fields: [] },
  { id: 'customers', label: 'Customers', visible: true, mode: 'builtin', fields: [] },
  { id: 'contractors', label: 'Contractors', visible: true, mode: 'builtin', fields: [] },
  { id: 'settings', label: 'Settings', visible: true, mode: 'builtin', fields: [] }
];

export const BUILTIN_TAB_LABEL_OVERRIDES = {
  transactions: 'Inventory Ledger'
};
